<script setup>
import { ref, defineExpose, watch, inject, computed } from "vue"
import i18n from "@/i18n"
import Swal from "sweetalert2";
import heatImg from '@/assets/img/thermal_comfort.png';
import customFieldCom from "./common/customField.vue";
// import customTableCom from "./common/customTable.vue";
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
import { useRoute } from "vue-router";
const route = useRoute()
const detailInfo = inject('detailInfo')
const currentTabLang = inject('currentTabLang') //切换语言
const showType = inject('showType') // 判断是服装还是其他  服装需要上传dat  服装会有内层外层。。。
const tabList = inject('tabList')
const current_tab = inject('current_tab')
//热湿舒适度
const heatList = ref([
    {
        name: getLangValueByKey('product-template.comfort_info_humidity_heat_comfort'),
        name_en: getLangValueByKey('product-template.comfort_info_humidity_heat_comfort', 'en'),
        fileList: [],
        showDelete: true,
        id: 'heatFiledUpload',
        accept: '.dat', // 接受的类型
        fileMaxSize: 1024 * 1024 * 50, //50M
        isShow: true,
    }
])
const heatListShowLen = ref(computed(() => heatList.value.filter(item => item.isShow).length))

const getInfo = computed(() => {
    // 动态拼接组成结构文字信息
    return currentTabLang.value == 1 ? `${(getLangValueByKey("attribute.structure")) + getLangValueByKey('upload.typeExcel')}${getLangValueByKey('upload.limit')}50M` :
        `${(getLangValueByKey("attribute.structure", 'en')) + getLangValueByKey('upload.typeExcel', 'en')}${getLangValueByKey('upload.limit', 'en')}50M`
})
const getInfo1 = computed(() => {
    // 动态拼接热湿舒适度上传文字信息
    return currentTabLang.value == 1 ? `${getLangValueByKey('upload.limit')}50M` : `${getLangValueByKey('upload.limit', 'en')}50M`
})

// 自定义的字段list 包含有上传框的
const customFieldsList = ref([
    {
        //FTT织物触觉测试
        name: getLangValue('product-template.comfort_info_ftt'), // 文本名称
        name_en: getLangValueByKey('product-template.comfort_info_ftt', 'en'), // 文本名称
        uukey: 'FTT',
        key: 'FTT织物触觉测试',
        isShow: true,
        fieldsList: [
            {
                name: getLangValueByKey("attribute.structure"), //字段名称
                name_en: getLangValueByKey("attribute.structure", 'en'),
                unit: '%', //字段单位
                value: '',
                key: getLangValue("attribute.structure"),
                required: false, // 字段必填项
            },
            // {
            //     name: i18n.global.t("attribute.water_contact_angle"), //字段名称
            //     unit: 'deg', //字段单位
            //     value: '',
            //     key: i18n.global.t("attribute.water_contact_angle"),
            // },
            // {
            //     name: i18n.global.t("attribute.water_contact_angle"), //字段名称
            //     unit: 'cm', //字段单位
            //     key: i18n.global.t("attribute.water_contact_angle"),
            // },
        ],
        showUpload: true,
        hideCopy: true, //去掉copy按钮
        showName: true, //显示label不显示输入框
        showDelete: true,
        info: getInfo,
        id: 'FTTFiledUpload',
        accept: '.xlsx, .xls', // 接受的类型
        fileMaxSize: 1024 * 1024 * 50, //50M
        fileList: [],
    },
    {
        //织物液态水分传导性能
        name: getLangValueByKey('product-template.comfort_info_mmt'), // 文本名称
        name_en: getLangValueByKey('product-template.comfort_info_mmt', 'en'),
        uukey: 'water',
        key: '织物液态水分传导性能',
        isShow: true,
        fieldsList: [
            {
                name: getLangValueByKey("product-template.bottom_water_contact_angle"), //字段名称
                name_en: getLangValueByKey("product-template.bottom_water_contact_angle", 'en'), //字段名称
                unit: 'deg', //字段单位
                value: '',
                key: getLangValue("product-template.bottom_water_contact_angle"),
                required: false, // 字段必填项
            },
            // {
            //     name: getLangValue("product-template.bottom_water_contact_angle"), //字段名称
            //     unit: 'deg', //字段单位
            //     value: '',
            //     key: getLangValue("product-template.bottom_water_contact_angle"),
            // },
            // {
            //     name: i18n.global.t("attribute.water_contact_angle"), //字段名称
            //     unit: 'cm', //字段单位
            //     value: '',
            //     key: i18n.global.t("attribute.water_contact_angle"),
            // },
        ],
        showUpload: true,
        hideCopy: false,
        showDelete: true,
        showName: true,
        info: getInfo1,
        id: 'iquid_waterFiledUpload',
        accept: '', // 接受的类型
        fileMaxSize: 1024 * 1024 * 50, //50M
        fileList: [],
    },
    {
        //膜性能
        name: getLangValueByKey('product-template.membrane_performance'), // 文本名称 
        name_en: getLangValueByKey('product-template.membrane_performance', 'en'), // 文本名称 
        uukey: 'membrane',
        key: '膜性能',
        isShow: true,
        fieldsList: [
            {
                name: getLangValueByKey("attribute.membrane_thickness"), //字段名称
                name_en: getLangValueByKey("attribute.membrane_thickness", 'en'), //字段名称
                unit: 'deg', //字段单位
                key: getLangValue("attribute.membrane_thickness"),
                required: false, // 字段必填项
            },
            {
                name: getLangValueByKey("attribute.membrane_type"), //字段名称
                name_en: getLangValueByKey("attribute.membrane_type", 'en'), //字段名称
                unit: '', //字段单位
                key: getLangValue("attribute.membrane_type"),
                type: 'select',
                list: [
                    'CV',
                    'DX',
                    'HP',
                    'MF',
                    'PP',
                    'PPTFE-laminated',
                    'PU',
                    'WPBF',
                    'WPBF',
                ]
            },
            {
                name: getLangValueByKey("attribute.membrane_location"), //字段名称
                name_en: getLangValueByKey("attribute.membrane_location", 'en'), //字段名称
                unit: '', //字段单位
                key: getLangValue("attribute.membrane_location"),
                type: 'select',
                list: [
                    {name: getLangValueByKey("product-template.inner"), name_en: getLangValueByKey("product-template.inner", 'en')},
                    {name: getLangValueByKey("product-template.outer"), name_en: getLangValueByKey("product-template.outer", 'en')},
                    {name: getLangValueByKey("product-template.middle"), name_en: getLangValueByKey("product-template.middle", 'en')}
                ],
            },
        ],
        // showUpload: true,
        showUpload: false,
        showDelete: true,
        hideCopy: false,
        showName: true,
        // info: `${i18n.global.t('upload.limit')}50M`,
        // id: 'membraneFiledUpload',
        // accept: '', // 接受的类型
        // fileMaxSize: 1024 * 1024 * 50, //50M
        // fileList: [],
        showTable: true,
        tabList: [
            {
                name: getLangValueByKey('product-template.water_vapor_permeability'),
                name_en: getLangValueByKey('product-template.water_vapor_permeability', 'en'),
                tableHeader: [
                    getLangValueByKey("product-template.number"),
                    getLangValueByKey("attribute.temperature"),
                    getLangValueByKey("attribute.water_vapor_permeability"),
                ],
                tableHeader_en: [
                    getLangValueByKey("product-template.number", 'en'),
                    getLangValueByKey("attribute.temperature", 'en'),
                    getLangValueByKey("attribute.water_vapor_permeability", 'en'),
                ],
                headerList: ["product-template.number", "attribute.temperature", "attribute.water_vapor_permeability"],
                tableList: [
                    {
                        value1: '',
                        value2: '',
                    },
                ],
                tableList_en: [
                    {
                        value1: '',
                        value2: '',
                    },
                ],
                showDelete: true
            },
            {
                name: getLangValueByKey('product-template.thermal_resistance'),
                name_en: getLangValueByKey('product-template.thermal_resistance', 'en'),
                tableHeader: [
                    getLangValueByKey("product-template.number"),
                    getLangValueByKey("attribute.temperature"),
                    getLangValueByKey("attribute.thermal_resistance"),
                ],
                tableHeader_en: [
                    getLangValueByKey("product-template.number", 'en'),
                    getLangValueByKey("attribute.temperature", 'en'),
                    getLangValueByKey("attribute.thermal_resistance", 'en'),
                ],
                headerList: ["product-template.number", "attribute.temperature", "attribute.thermal_resistance"],
                tableList: [
                    {
                        value1: '',
                        value2: '',
                    },
                ],
                tableList_en: [
                    {
                        value1: '',
                        value2: '',
                    },
                ],
                showDelete: true
            }
        ]
    },
    {
        //相变资料
        name: getLangValueByKey('product-template.phase_change_data'), // 文本名称
        name_en: getLangValueByKey('product-template.phase_change_data', 'en'), // 文本名称
        uukey: 'disguised',
        key: '相变资料',
        isShow: true,
        fieldsList: [
            {
                name: getLangValueByKey("attribute.phase_change_material_add_on_level"), //字段名称
                name_en: getLangValueByKey("attribute.phase_change_material_add_on_level", 'en'), //字段名称
                unit: '%', //字段单位
                value: '',
                key: getLangValue('attribute.phase_change_material_add_on_level'),
                required: false, // 字段必填项
            },
            // {
            //     name: i18n.global.t("attribute.radius"), //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: i18n.global.t('attribute.radius')
            // },
            // {
            //     name: i18n.global.t("attribute.density"), //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: i18n.global.t('attribute.density')
            // },
        ],
        showUpload: false,
        showDelete: true,
        hideCopy: false,
        showName: true,
    },
    {
        //自加热
        name: getLangValueByKey('product-template.self_heating'), // 文本名称
        name_en: getLangValueByKey('product-template.self_heating', 'en'), // 文本名称
        uukey: 'heat',
        key: '自加热',
        isShow: true,
        fieldsList: [
            {
                name: getLangValueByKey("attribute.heating_load"), //字段名称
                name_en: getLangValueByKey("attribute.heating_load", 'en'), //字段名称
                unit: '', //字段单位
                value: '',
                key: getLangValue('attribute.heating_load'),
                required: false, // 字段必填项
            },
            // {
            //     name: i18n.global.t("attribute.switch_on_temperature"), //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: i18n.global.t('attribute.switch_on_temperature')
            // },
            // {
            //     name: i18n.global.t("attribute.switch_off_temperature"), //字段名称
            //     unit: 'deg', //字段单位
            //     value: '',
            //     key: i18n.global.t('attribute.switch_off_temperature')
            // },
        ],
        showUpload: false,
        showDelete: true,
        hideCopy: false,
        showName: true,
        showTable: true,
        tabList: [
            {
                name: getLangValueByKey('product-template.tensile_property'),
                name_en: getLangValueByKey('product-template.tensile_property', 'en'),
                tableHeader: [
                    getLangValueByKey("product-template.number"),
                    getLangValueByKey("attribute.tensile_stress"),
                    getLangValueByKey("attribute.tensile_strain"),
                ],
                tableHeader_en: [
                    getLangValueByKey("product-template.number", 'en'),
                    getLangValueByKey("attribute.tensile_stress", 'en'),
                    getLangValueByKey("attribute.tensile_strain", 'en'),
                ],
                headerList: ["product-template.number", "attribute.tensile_stress", "attribute.tensile_strain"],
                tableList: [
                    {
                        value1: '',
                        value2: '',
                    },
                    {
                        value1: '',
                        value2: '',
                    }
                ],
                showDelete: true
            },
            {
                name: getLangValueByKey('product-template.breathability'),
                name_en: getLangValueByKey('product-template.breathability', 'en'),
                tableHeader: [
                    getLangValueByKey("product-template.number"),
                    getLangValueByKey("attribute.pressure_range"),
                    getLangValueByKey("attribute.flow_rate"),
                ],
                tableHeader_en: [
                    getLangValueByKey("product-template.number", 'en'),
                    getLangValueByKey("attribute.pressure_range", 'en'),
                    getLangValueByKey("attribute.flow_rate", 'en'),
                ],
                headerList: ["product-template.number", "attribute.pressure_range", "attribute.flow_rate"],
                tableList: [
                    {
                        value1: '',
                        value2: '',
                    },
                    {
                        value1: '',
                        value2: '',
                    }
                ],
                tableList_en: [
                    {
                        value1: '',
                        value2: '',
                    },
                    {
                        value1: '',
                        value2: '',
                    }
                ],
                showDelete: true
            }
        ]
    }
])
const customFieldsListShowLen = ref(computed(() => customFieldsList.value.filter(item => item.isShow).length))
// 自定义table信息list
const customTableList = ref([
    {
        name: getLangValueByKey('product-template.tensile_property'),
        name_en: getLangValueByKey('product-template.tensile_property', 'en'),
        tableHeader: [
            getLangValueByKey("product-template.number"),
            getLangValueByKey("attribute.tensile_stress"),
            getLangValueByKey("attribute.tensile_strain"),
        ],
        tableHeader_en: [
            getLangValueByKey("product-template.number", 'en'),
            getLangValueByKey("attribute.tensile_stress", 'en'),
            getLangValueByKey("attribute.tensile_strain", 'en'),
        ],
        headerList: ["product-template.number", "attribute.tensile_stress", "attribute.tensile_strain"],
        tableList: [
            {
                value1: '',
                value2: '',
            },
            {
                value1: '',
                value2: '',
            }
        ],
        tableList_en: [
            {
                value1: '',
                value2: '',
            },
            {
                value1: '',
                value2: '',
            }
        ],
        showDelete: true
    },
    {
        name: getLangValueByKey('product-template.breathability'),
        name_en: getLangValueByKey('product-template.breathability', 'en'),
        tableHeader: [
            getLangValueByKey("product-template.number"),
            getLangValueByKey("attribute.pressure_range"),
            getLangValueByKey("attribute.flow_rate"),
        ],
        tableHeader_en: [
            getLangValueByKey("product-template.number", 'en'),
            getLangValueByKey("attribute.pressure_range", 'en'),
            getLangValueByKey("attribute.flow_rate", 'en'),
        ],
        headerList: ["product-template.number", "attribute.pressure_range", "attribute.flow_rate"],
        tableList: [
            {
                value1: '',
                value2: '',
            },
            {
                value1: '',
                value2: '',
            }
        ],
        tableList_en: [
            {
                value1: '',
                value2: '',
            },
            {
                value1: '',
                value2: '',
            }
        ],
        showDelete: true
    }
])
const customTableListShowLen = ref(computed(() => customTableList.value.filter(item => item.isShow).length))
//自定义字段list 底部
const customFieldsList1 = ref([
    {
        name: getLangValueByKey('product-template.template_text'), // 文本名称
        name_en: getLangValueByKey('product-template.template_text', 'en'), // 文本名称
        fieldsList: [
            {
                name: getLangValueByKey('product-template.template_text_field'), //字段名称
                name_en: getLangValueByKey('product-template.template_text_field', 'en'), //字段名称
                unit: '', //字段单位
                value: '',
                key: '字段1',
                required: false, // 字段必填项
            },
            // {
            //     name: '字段2', //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: '字段2',
            // },
            // {
            //     name: '字段3', //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: '字段3',
            // },
        ],
        showUpload: false,
        showDelete: true,
        isShow: false,
    },
    {
        name: getLangValueByKey('product-template.template_text_attachment'), // 文本名称 
        name_en: getLangValueByKey('product-template.template_text_attachment', 'en'), // 文本名称 
        fieldsList: [
            {
                name: getLangValueByKey('product-template.template_text_field'), //字段名称
                name_en: getLangValueByKey('product-template.template_text_field', 'en'), //字段名称
                unit: '', //字段单位
                value: '',
                key: '字段1',
                required: false, // 字段必填项
            },
            // {
            //     name: '字段2', //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: '字段2',
            // },
            // {
            //     name: '字段3', //字段名称
            //     unit: '', //字段单位
            //     value: '',
            //     key: '字段3',
            // },
        ],
        isShow: false,
        showUpload: true,
        showDelete: true,
        id: 'comfortcustomFiledUpload',
        accept: '', // 接受的类型
        fileMaxSize: 1024 * 1024 * 200, //200M
        fileList: [],
    }
])
const ccustomFieldsList1ShowLen = ref(computed(() => customFieldsList1.value.filter(item => item.isShow).length)) // 自定义弹框长度
//方法
const deleteHeat = () => {
    // 删除 热湿舒适度
    Swal.fire({
        title: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_title"): getLangValueByKey("base.delete_alert_title", 'en'),
        text: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_info"): getLangValueByKey("base.delete_alert_info", 'en'),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
    }).then(async (result) => {
        if (result.isConfirmed) {
            heatList.value.pop()
            showType.value = false;
        }
    });

}

const editFields = (i) => {
    //tab 字段名称修改
    const { name, name_en } = heatList.value[i];
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if (currentTabLang.value == 1) {
                    heatList.value[i].name = value
                } else {
                    heatList.value[i].name_en = value
                }

                // emits('update:uploadList', uploadList.value)
            }
        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}

// 自定义字段校验
const checkForm = () => {
    let flag = true
    for (let k in customFieldsList1.value) {
        if (!customFieldsList1.value[k].name) {
            flag = false
            currentTabLang.value = 1;
            break
        }
        if (!customFieldsList1.value[k].name_en) {
            flag = false
            currentTabLang.value = 2;
            break
        }
    }
    return flag
}

// 筛选出重复项
const findDuplicates = (arr) => {
    const map = new Map();
    const duplicates = arr.filter(item => {
        if (!map.has(item)) {
            map.set(item, 1);
            return false;
        } else {
            map.set(item, map.get(item) + 1);
            return true;
        }
    });
    return duplicates;
};

// check 每个模板名称是否重复
const checkRepeat1 = () => {
    let checkRes1 = true;
    let arr = []
    let arr1 = []
    let moduleName = ''
    // 上传框
    for (let k in customFieldsList.value) {
        if (customFieldsList.value[k].isShow) {
            arr.push(customFieldsList.value[k].name);
            arr1.push(customFieldsList.value[k].name_en);
        }
    }
    // 上传框
    for (let k in customTableList.value) {
        if (customTableList.value[k].isShow) {
            arr.push(customTableList.value[k].name);
            arr1.push(customTableList.value[k].name_en);
        }
    }
    // 自定义字段
    for (let k in customFieldsList1.value) {
        if (customFieldsList1.value[k].isShow) {
            arr.push(customFieldsList1.value[k].name);
            arr1.push(customFieldsList1.value[k].name_en);
        }
    }
    // 去重
    // console.log(arr);
    let uniqueArr = Array.from(new Set(arr))
    let uniqueArr1 = Array.from(new Set(arr1))
    // console.log(uniqueArr);
    if (uniqueArr.length != arr.length) {
        // 重复名称
        const duplicates = findDuplicates(arr);
        moduleName = duplicates.join(',');
        checkRes1 = false
        currentTabLang.value = 1;
    }
    if (uniqueArr1.length != arr1.length) {
        // 重复名称
        const duplicates = findDuplicates(arr1);
        moduleName = duplicates.join(',');
        checkRes1 = false
        currentTabLang.value = 2;
    }
    return { checkRes1, moduleName }
}



// 监听detailInfo 组装数据
watch(detailInfo, (val) => {
    const { comfort_info } = val
    if (typeof comfort_info == 'undefined') return
    // console.log('ci', comfort_info);
    //设置热湿舒适度
    const heList = comfort_info.children.filter(item => item.key == "comfort_info_humidity_heat_comfort")
    if (heList.length) {
        heatList.value = [{
            name: heList[0].name,
            name_en: heList[0].name_en,
            fileList: [],
            showDelete: true,
            isShow: heList[0].show,
        }]
    } else {
        showType.value = false;
        heatList.value = []
    }
    //自定义字段list  uukey存在的那五个 
    const cfList = comfort_info.children.filter(item => item.extra && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && item.extra.uukey)
    // console.log(cfList);
    if (cfList.length) {
        customFieldsList.value = cfList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                fieldsList: [],
                uukey: item.extra.uukey,
                key: item.key,
                isShow: item.show,
            }
            if (item.extra.myKey == '文本项') {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.hideCopy = item.extra.hideCopy
                m.showName = item.extra.showName
                m.showTable = item.extra.showTable ? true : false,
                    m.tabList = item.extra.tabList ? item.extra.tabList : []
            } else {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.hideCopy = item.extra.hideCopy
                m.showName = item.extra.showName
                m.info = `${i18n.global.t('upload.limit')}50M`
                m.id = item.extra.id
                // m.accept = m.accept
                m.fileMaxSize = 1024 * 1024 * 50
                m.fileList = []
                m.showTable = item.extra.showTable ? true : false,
                    m.tabList = item.extra.tabList ? item.extra.tabList : []
            }
            if (item.children)
                m.fieldsList = item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: "",
                        required: ele.required,
                        type: ele.extra && ele.extra.type ? ele.extra.type : '',
                        list: ele.extra && ele.extra.list ? ele.extra.list : []
                    }
                })
            return m
        })
        // console.log(customFieldsList.value);
    } else {
        customFieldsList.value = []
    }
    //自定义table
    // const csTList = comfort_info.children.filter(item => item.extra && item.extra.myKey == '数据表')
    // if (csTList.length) {
    //     customTableList.value = csTList.map(item => {
    //         let m = {
    //             name: item.name,
    //             tableHeader: [
    //                 i18n.global.t(item.extra.headerList[0]),
    //                 i18n.global.t(item.extra.headerList[1]),
    //                 i18n.global.t(item.extra.headerList[2]),
    //             ],
    //             headerList: item.extra.headerList,
    //             tableList: item.extra.tableList,
    //             showDelete: item.extra.showDelete
    //         }
    //         return m
    //     })
    // } else {
    //     customTableList.value = []
    // }
    //自定义table
    //自定义字段list底部  uukey不存在的 说明是底部的信息
    const csFList = comfort_info.children.filter(item => item.extra && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && !item.extra.uukey)
    if (csFList.length) {
        customFieldsList1.value = csFList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                fieldsList: [],
                uukey: item.uukey,
                isShow: item.show,
            }
            if (item.extra.myKey == '文本项') {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
            } else {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.id = item.extra.id
                m.accept = ""
                m.fileMaxSize = 1024 * 1024 * 200
                m.fileList = []
            }
            if (item.children)
                m.fieldsList = item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: '',
                        required: ele.required,
                    }
                })
            return m
        })
    } else {
        customFieldsList1.value = []
    }
})
defineExpose({
    heatList,
    customFieldsList,
    customTableList,
    customFieldsList1,
    checkForm,
    checkRepeat1,
})


watch(() => customFieldsList.value.length + heatList.value.length + customTableList.value.length + customFieldsList1.value.length, (val) => {
    // 如果整个模板都没数据就隐藏
    if (val == 0) {
        // console.log(tabList);
        tabList.value[1].show = false;
        current_tab.value = 0
    }
})

watch(() => heatListShowLen.value + customFieldsListShowLen.value + customTableListShowLen.value + ccustomFieldsList1ShowLen.value, (val) => {
    // 如果整个模板都没数据就隐藏
    if (val == 0 && route.query.type == 'view') {
        // console.log(tabList);
        tabList.value[1].show = false;
        current_tab.value = 0
    }
})

</script>
<template>
    <!-- 热湿舒适度 -->
    <template v-for="(item, index) in heatList" :key="index">
        <b-card v-show="route.query.type != 'view' || (route.query.type == 'view' && item.isShow)">
            <div class="row gy-3 w-100">
                <div class="d-flex justify-content-between align-items-center pt-2 pb-2"
                    style="font-weight: 500;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                    <div>
                        {{ currentTabLang == 1 ? item.name : item.name_en }}
                        <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                            @click.stop="editFields(index)"></i>
                    </div>
                    <!-- <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3"
                    style="background-color: #F06548;border:unset" @click="deleteHeat">
                    <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                    {{ getLangValue("base.delete") }}
                </button> -->
                    <div class="d-flex justify-content-between" style="width: 97px;">
                        <div class="form-check form-switch form-switch-success" v-if="route.query.type != 'view'">
                            <input class="form-check-input" v-model="item.isShow" @change="handlerSwitch"
                                type="checkbox" role="switch" id="SwitchCheck3" checked>
                        </div>
                        <i @click="deleteHeat" style="color:#ED5E5E"
                            v-show="item.showDelete && route.query.type != 'view'"
                            class=" cursor-pointer ri-delete-bin-5-fill me-1 align-bottom"></i>
                    </div>
                </div>
                <!-- 字段部分 -->
                <div class="row  d-flex ">
                    <div style="flex:4">
                        <img :src="heatImg" style="height: 286px; object-fit: contain;" />
                    </div>
                    <div style="flex:6">
                        <div class="mt-4 mb-4">
                            {{ currentTabLang == 2 ? getLangValueByKey("product-template.thermalComfortDat", 'en') :
                                getLangValueByKey("product-template.thermalComfortDat") }}
                        </div>
                        <!-- 上传框 -->
                        <div style="pointer-events: none;">
                            <div></div>
                            <DropZone1 :accept="'.png,.jpeg,.jpg,'" :currentTab="currentTabLang"
                                :title="currentTabLang == 1 ? getLangValueByKey('upload.title') : getLangValueByKey('upload.title', 'en')"
                                @drop.prevent="drop" @change.prevent="selectedFile('2d')" style="min-height: 220px"
                                :info="currentTabLang == 1 ? (getLangValueByKey('upload.limit') + '50M') : getLangValueByKey('upload.limit', 'en') + '50M'" />
                        </div>
                    </div>
                </div>

            </div>
        </b-card>
    </template>
    <!-- 字段图片上传部分 -->
    <customFieldCom v-model:customFieldsList="customFieldsList" />
    <!-- 自定义表格部分 -->
    <!-- <customTableCom :customTableList="customTableList" /> -->
    <!-- 自定义字段及上传 -->
    <customFieldCom v-model:customFieldsList="customFieldsList1" />
</template>
<style scoped></style>